<ce-modal class="SwitchOrganization">
    <ce-modal-header>Switch organization</ce-modal-header>

    <ce-modal-content>
        <div class="flex-between u-spacing-md-mb">
            <ds-search-dropdown
                [formControl]="organizationDropdownControl"
                [searchData]="organizationSearchData()"
                label="Organization"
                [placeholder]="'Search organization'"
                [prefixType]="'name'"
            />
        </div>

        @if (selectedOrganizationId() && !userIsSystemAdmin()) {
        <div class="flex-col u-spacing-lg-mt">
            <span class="flex-col u-spacing-none-ph u-spacing-md-mb u-text-label-sm u-color-text-secondary">Your role for this organization</span>

            <ce-list [size]="'sm'" [select]="userIsSystemAdmin()">
                @for (sysRole of nonSysadminRoles().sysRoles; track $index){
                <ce-list-item>
                    <svg ce-list-item-prefix xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path
                            d="M10.525 16.55L17.6 9.475L16.45 8.35L10.525 14.275L7.525 11.275L6.4 12.4L10.525 16.55ZM12 22C10.6333 22 9.34167 21.7375 8.125 21.2125C6.90833 20.6875 5.84583 19.9708 4.9375 19.0625C4.02917 18.1542 3.3125 17.0917 2.7875 15.875C2.2625 14.6583 2 13.3667 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.02917 5.825 4.9375 4.925C5.84583 4.025 6.90833 3.3125 8.125 2.7875C9.34167 2.2625 10.6333 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3667 21.7375 14.6583 21.2125 15.875C20.6875 17.0917 19.975 18.1542 19.075 19.0625C18.175 19.9708 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20.5C14.3667 20.5 16.375 19.6708 18.025 18.0125C19.675 16.3542 20.5 14.35 20.5 12C20.5 9.63333 19.675 7.625 18.025 5.975C16.375 4.325 14.3667 3.5 12 3.5C9.65 3.5 7.64583 4.325 5.9875 5.975C4.32917 7.625 3.5 9.63333 3.5 12C3.5 14.35 4.32917 16.3542 5.9875 18.0125C7.64583 19.6708 9.65 20.5 12 20.5Z"
                            fill="#AFAFAF"
                        />
                    </svg>

                    <span ce-list-item-title class="u-text-label-md">
                        {{ sysRole?.name }}
                    </span>
                    <span ce-list-item-description class="u-text-body-sm u-color-text-secondary"> {{ sysRole?.description }}</span>
                </ce-list-item>
                } @for (customRole of nonSysadminRoles().customRoles; track $index){
                <ce-list-item>
                    <svg ce-list-item-prefix xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path
                            d="M10.525 16.55L17.6 9.475L16.45 8.35L10.525 14.275L7.525 11.275L6.4 12.4L10.525 16.55ZM12 22C10.6333 22 9.34167 21.7375 8.125 21.2125C6.90833 20.6875 5.84583 19.9708 4.9375 19.0625C4.02917 18.1542 3.3125 17.0917 2.7875 15.875C2.2625 14.6583 2 13.3667 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.02917 5.825 4.9375 4.925C5.84583 4.025 6.90833 3.3125 8.125 2.7875C9.34167 2.2625 10.6333 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3667 21.7375 14.6583 21.2125 15.875C20.6875 17.0917 19.975 18.1542 19.075 19.0625C18.175 19.9708 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20.5C14.3667 20.5 16.375 19.6708 18.025 18.0125C19.675 16.3542 20.5 14.35 20.5 12C20.5 9.63333 19.675 7.625 18.025 5.975C16.375 4.325 14.3667 3.5 12 3.5C9.65 3.5 7.64583 4.325 5.9875 5.975C4.32917 7.625 3.5 9.63333 3.5 12C3.5 14.35 4.32917 16.3542 5.9875 18.0125C7.64583 19.6708 9.65 20.5 12 20.5Z"
                            fill="#AFAFAF"
                        />
                    </svg>
                    <span ce-list-item-title class="u-text-label-md">
                        {{ customRole?.name }}
                        <span ce-list-item-description class="u-text-body-sm u-color-text-secondary">(custom)</span>
                    </span>
                </ce-list-item>
                }
            </ce-list>
        </div>
        }
        <!-- NOTE: we should also check if user is not impersonating-->
        @if (selectedOrganizationId() && userIsSystemAdmin()) {

        <div class="u-spacing-md-mb u-spacing-lg-mt">
            <span class="flex flex-col u-spacing-sm-mb u-color-text-secondary u-text-label-sm">User role(s)</span>
            <ce-dropdown [control]="roleControl" [multiple]="true">
                <ce-dropdown-trigger>
                    <span [ngClass]="{ 'u-color-text-placeholder': roleTriggerText().selectedRolesTotal === 0 }">
                        {{ roleTriggerText().text }}
                    </span>
                </ce-dropdown-trigger>

                @for (role of systemRolesArray; track role; ) {

                <ce-dropdown-option [value]="role[1]">
                    <span ce-dropdown-option-title class="u-text-body-md"> {{ role[1] }} </span>
                    <span ce-dropdown-option-description class="u-text-body-sm u-color-text-secondary">{{ role[2] }}</span>
                </ce-dropdown-option>
                } @if (customRolesList()) { @for (role of customRolesList(); track role; ) {
                <ce-dropdown-option [value]="role.name">
                    <span ce-dropdown-option-title> {{ role.name }} <span class="u-text-label-md u-color-text-secondary">(custom)</span> </span>
                </ce-dropdown-option>
                } }
            </ce-dropdown>
        </div>
        }
    </ce-modal-content>
    <ce-modal-actions class="SwitchOrganization-button">
        @if (impersonationUpdating()) {
        <span class="u-text-body-sm">Updating</span> <ce-spinning-loader-sm class="flex flex-middle" />
        } @else {
        <button ce-button ce-button-default ce-button-type-secondary (click)="cancel()">Cancel</button>
        <button ce-button ce-button-default (click)="select()" [disabled]="!isAllowedSwitchOrg()">Switch organization</button>
        }
    </ce-modal-actions>
</ce-modal>
